import { render, staticRenderFns } from "./PicExpert.vue?vue&type=template&id=4209612d&scoped=true"
import script from "./PicExpert.vue?vue&type=script&lang=js"
export * from "./PicExpert.vue?vue&type=script&lang=js"
import style0 from "./PicExpert.vue?vue&type=style&index=0&id=4209612d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4209612d",
  null
  
)

export default component.exports